<template>
	<div>
		<md-field displayOnly>
			<label>{{ $t("common.debtor") }}</label>
			<md-input :value="formData.debtorName" disabled></md-input>
		</md-field>
		<div class="flex">
			<md-field class="margin_r" displayOnly>
				<label>{{ $t("common.applicableLaw") }}</label>
				<md-input :value="formData.applicableLaw" disabled></md-input>
			</md-field>
			<md-field displayOnly>
				<label>{{ $t("revolvingPutOption.paymentTerms") }}</label>
				<md-input :value="formData.paymentTerm" disabled></md-input>
			</md-field>
		</div>
		<div class="flex">
			<md-field class="margin_r" displayOnly>
				<label>{{ $t("revolvingPutOption.salesPeriod") }}</label>
				<md-input :value="formData.startDate + ' - ' + formData.endDate" disabled></md-input>
			</md-field>
			<md-field displayOnly>
				<label>{{ $t("revolvingPutOption.revolvingLine") }}</label>
				<md-input :value="formData.saleLimit" disabled></md-input>
			</md-field>
		</div>
		<div class="flex">
			<md-field class="margin_r" displayOnly>
				<label>{{ $t("revolvingPutOption.discount") }}</label>
				<md-input :value="formData.discountRate" disabled></md-input>
			</md-field>
			<md-field displayOnly>
				<label>{{ $t("revolvingPutOption.premium") }}</label>
				<md-input :value="formData.premium" disabled></md-input>
			</md-field>
		</div>
		<div class="flex">
			<md-field class="flex_1 margin_r" displayOnly>
				<label>{{ $t("common.assignmentType") }}</label>
				<TbSelect v-model="formData.disclosed"
						  :options="assignmentOptions"
						  options-value-field="disclosed"
						  :options-display-getter="(item) => $t(item.translationKey)"
						  :disabled="true"
				/>
			</md-field>
			<DurrationSelect class="flex_1" displayOnly
							 v-model="formData.auctionDurationInHours"
							 :disabled="true"
							 :no-table="true"
			></DurrationSelect>
		</div>
	</div>
</template>

<script>
import {formatAsDecimal, formatAsLocalizedDate, formatAsMoneyAmount} from "@/common/format";
import DurrationSelect from "@/components/templates/seller/sell/DurrationSelect";
import enumStatus from "@/common/enum";

export default {
	components: {
		DurrationSelect
	},
	props: {
		optionData: { type: Object, default: null }
	},
	data() {
		return {
			assignmentOptions: enumStatus.discloseList,
		};
	},
	computed: {
		formData() {
			if (!this.optionData) {
				return {};
			}

			return {
				...this.optionData,
				startDate: formatAsLocalizedDate(this.optionData.startDate),
				endDate: formatAsLocalizedDate(this.optionData.endDate),
				saleLimit: formatAsMoneyAmount(this.optionData.saleLimit, { currency: this.optionData.currency }),
				discountRate: formatAsDecimal(this.optionData.discountRate, { showPercentSign: true }),
				premium: formatAsDecimal(this.optionData.premium, { showPercentSign: true }),
			}
		},
	}
};
</script>